module.exports = __webpack_public_path__ + "assets/img/favicon/favicon-32x32.ca69fd97b6512fe7f4b2af881d81317f.png";